var galeria = function () {
    Array.from(document.querySelectorAll('.galeria'), function (bloque) {
        var activo = 0;
        var imagenes = Array.from(bloque.querySelectorAll('.galeria__imagen'));
        setInterval(function () {
            imagenes[activo].classList.remove('activa');
            activo = (activo + 1) % imagenes.length;
            imagenes[activo].classList.add('activa');
        }, 5000);
    });
};
export default galeria;
